require('./RAContributionBar.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const BarEnd = require('./RAContributionBarEnd/RAContributionBarEnd');
const BarArrows = require('./RAContributionBarArrows/RAContributionBarArrows');

class RAContributionBar extends React.Component {
    render() {
        const {
            color,
            height,
            width,
            endingBar,
            endingBarTopPosition,
            startingBar,
            startingBarTopPosition,
            renderAfter,
            top,
            left,
        } = this.props;

        let after = null;
        if (renderAfter) {
            after = (
                <div className="ra-contribution-bar__end">
                    <div className="ra-contribution-bar__end--after">{renderAfter()}</div>
                </div>
            );
        }

        const style = { backgroundColor: color, height, width, top, left };

        return (
            <div className="ra-contribution-bar" style={style}>
                <div className="ra-contribution-bar__children">{this.props.children}</div>
                <div className="ra-contribution-bar__start" style={{ top: startingBarTopPosition }}>
                    {startingBar}
                </div>
                <div className="ra-contribution-bar__end" style={{ top: endingBarTopPosition }}>
                    {endingBar}
                </div>
                {after}
            </div>
        );
    }
}

RAContributionBar.End = BarEnd;
RAContributionBar.ArrowsChildren = BarArrows;

RAContributionBar.defaultProps = {
    endingBar: null,
    endingBarTopPosition: '0',
    startingBar: null,
    startingBarTopPosition: '0',
    left: '0',
};

RAContributionBar.propTypes = {
    children: PropTypes.element,
    color: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.number.isRequired,
    endingBar: PropTypes.element,
    endingBarTopPosition: PropTypes.string.isRequired,
    startingBar: PropTypes.element,
    startingBarTopPosition: PropTypes.string.isRequired,
    renderAfter: PropTypes.func,
};

module.exports = RAContributionBar;
